export const MAX_DAYS_THRESHOLD_FOR_USAGE_CHART = 90;
export const OVERVIEW_CACHE_TTL_MS = 1000 * 30;
